export default __webpack_public_path__ + "static/media/background.fd23179e.webp";